import { GetNationalityAdapter } from '../../../adapter';

export default async function GetNationalityUseCase(event) {
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcr.dev.bpimsapps.com');
    const isUAT = url.includes('hcr.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionrenewal.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
            ? 'https://partners-api.dev.bpimsapps.com/data-get/nationality'
            : isUAT
            ? 'https://partners-api.uat.bpimsapps.com/data-get/nationality'
            : isProd
            ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
                  flag ? '' : '/partners'
              }/data-get/nationality`
            : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
                  flag ? '' : '/partners'
              }/data-get/nationality`;

    // const requestUrl = 'https://partners-api.dev.bpimsapps.com/plans';

    const payload = { tables: ['countries'] };

    // handle request
    const result = await GetNationalityAdapter(endpoint, JSON.stringify(payload));

    return result.data;
}
